import { AssessmentGroupListFragmentFragment } from "types/graphql-schema";

import { ComboboxGenericOption } from "@components/combobox/generic-combobox";

import { questionCountLabel } from "../helpers";

// A question set in the picker's menu, with its question count at the right of
// the row. Opacity rather than a grey, so the count stays readable on the
// highlighted row.
export const toQuestionSetOption = ({
  id,
  title,
  questionCount,
}: AssessmentGroupListFragmentFragment): ComboboxGenericOption<number> => ({
  value: id,
  label: title,
  htmlLabel: (
    <>
      <span className="flex-1 truncate">{title}</span>
      <span className="shrink-0 self-center text-xs opacity-70">
        {questionCountLabel(questionCount)}
      </span>
    </>
  ),
});
